module.exports = __webpack_public_path__ + "img/電気回路_3_8.b9f88782.png";